// All 11 distinct Storefront API queries in the codebase were tested
// against versions 2021-10, 2022-10, 2024-01, 2025-10, 2026-01, 2026-04
// and unstable — every live query passes on every version. Unified on
// 2026-04 (latest stable) for the longest API support runway. Coordinated
// with global-state.js, blog.js, product-samples/index.js,
// product-quickshop.js so all consumers move to the same version.
const API_VERSION = '2026-04';
export const GRAPHQL_API_ENDPOINT = `${window.theme.storeURL}/api/${API_VERSION}/graphql.json`;

export const CUSTOMER_TAGS_ENDPOINT = `${process.env.SAMPLE_CUSTOMER_TAGS_ENDPOINT}`;

// Override storefront API token from env var (build-time substitution)
if (process.env.STOREFRONT_API_TOKEN && window.theme) {
  window.theme.storeFrontAPI = process.env.STOREFRONT_API_TOKEN;
}
